export default "__VITE_ASSET__BTx05zLM__"